<template>
  <div>
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Políticas</h2>
    </div>
    <router-view />
  </div>
</template>
